import React from 'react';
import PropTypes from "prop-types";

export default function LeftCaretSVG(props) {
  return (
    <svg
      id={props.id || ''}
      className={props.className || ''}
      height={props.styles.height || '15px'}
      width={props.styles.width || '15px'}
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 10 15" >
      <g transform="translate(-515.000000, -248.000000)">
        <polygon 
          id="back-15px" 
          fill={props.styles.fill} points="515,255.5 522.5,263 524.4,261.1 518.7,255.5 524.4,249.9 522.5,248"/>
      </g>
    </svg>
  );
}

LeftCaretSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
